<template>
  <span
    :class="{'material-icons':!!icon, 'material-icons-outlined':outlined}"
    class="mdc-icon mdc-icon--material">
    <slot>{{ icon }}</slot>
  </span>
</template>

<script>
export default {
  name: 'mdc-icon',
  props: {
    icon: String,
    outlined: {
      type: Boolean,
      default: false
    }
  }
}
</script>
